import { EvaluationColor } from '@repo/types';
import { evaluationColorToCSSVariableMap } from '@repo/ui/helpers/evaluationColors.js';
import { format } from 'date-fns';

import { userValueFormat } from 'helpers';

import ChartCustomTooltip from './ChartCustomTooltip';

const NEUTRAL_DOT_COLOR = 'var(--warm-grey-400)';

const dotColorByEvaluation: Record<EvaluationColor, string> = {
  ...evaluationColorToCSSVariableMap,
  grey: NEUTRAL_DOT_COLOR,
};

type SampleDotProps = {
  cx?: number;
  cy?: number;
  index?: number;
  payload?: {
    evaluation_color: string;
    user_value: number | null;
    sample_date: string;
  };
  sampleIndex: number | null;
  isActive: boolean;
  dataType: string;
};

const SampleDot = ({
  cx,
  cy,
  index,
  payload,
  sampleIndex,
  isActive,
  dataType,
}: SampleDotProps) => {
  if (cx === undefined || cy === undefined) return <></>;
  const color =
    dotColorByEvaluation[payload?.evaluation_color as EvaluationColor] ??
    NEUTRAL_DOT_COLOR;
  const isCurrentSample = index === sampleIndex;
  return (
    <g>
      {isCurrentSample && (
        <>
          <circle cx={cx} cy={cy} r={10} fill={color} fillOpacity={0.3} />
          <circle cx={cx} cy={cy} r={7.5} fill='white' fillOpacity={0.9} />
        </>
      )}
      <circle
        cx={cx}
        cy={cy}
        r={5}
        fill={isActive ? color : 'white'}
        stroke={color}
        strokeWidth={2}
      />
      {isActive && payload?.user_value != null && (
        <ChartCustomTooltip
          cx={cx}
          cy={cy}
          value={userValueFormat(payload.user_value, dataType)}
          date={format(new Date(payload.sample_date), 'MMM d, yyyy')}
        />
      )}
    </g>
  );
};

export default SampleDot;
